import DREColumnsContent from "./DREColumnsContent"
import { getBackgroundColor } from "./DREHelper"

/* eslint-disable */
const DRESubgroup = ({ subgroup }) => {
  const fullName = `${subgroup.classification} - ${subgroup.name}`

  return (
    <DREColumnsContent
      name={fullName}
      values={subgroup.values}
      total={subgroup.total}
      paddingLeft={3}
      canExpand={false}
      backgroundColor={getBackgroundColor(subgroup)}
    />
  )
}

export default DRESubgroup